import {Time} from 'yougile-util'
import {TableRow} from '../../common/base/table/types'
import {CrmActivitiesFilters, RowData} from '../common'
import {isThatDayByDate} from '../custom-format-date'

export const applyFilters = (
  tableRows: TableRow<RowData>[],
  filters: CrmActivitiesFilters
): TableRow<RowData>[] => {
  if (filters.page === 'day') {
    return tableRows.filter(
      row =>
        isThatDayByDate(row.data.activity.deadline, filters.selectedDay) &&
        !row.data.activity.completed
    )
  }
  if (filters.page === 'failed') {
    return tableRows.filter(
      row =>
        row.data.activity.deadline < Time.now() && !row.data.activity.completed
    )
  }
  if (filters.page === 'completed') {
    return tableRows.filter(row => row.data.activity.completed)
  }
  return tableRows
}
